import { Box, Chip, Paper, Skeleton, Typography } from "@mui/material";
import { useDrillDownDialog } from "../../../../dashboard-framework/DrillDownProvider";
import { DrillDownConfig, WidgetExplanationContent } from "../../../../dashboard-framework/types";
import { WidgetExplanation } from "../../../../dashboard-framework/widgets/WidgetExplanation";
import { createColoredCardSx } from "../../../../dashboard-framework/widgets/widgetStyles";

// Cartão de destaque da conversão (banda de topo). Usado para o Total, os tipos de cliente e cada grupo
// de perturbação; os grupos passam chips com a repartição adulto/criança. Reutiliza os blocos do StatCard
// (cartão colorido + ⓘ + drill), acrescentando subtítulo e chips — que o StatCard do framework não tem.
export type ConversionKpiChip = { label: string; value: string };

type ConversionKpiCardProps = {
    label: string;
    value: string;
    subtitle?: string;
    chips?: Array<ConversionKpiChip>;
    color: string;
    explanation: WidgetExplanationContent;
    isLoading?: boolean;
    drillDown?: DrillDownConfig;
};

export const ConversionKpiCard = ({ label, value, subtitle, chips, color, explanation, isLoading, drillDown }: ConversionKpiCardProps) => {
    const drillDownDialog = useDrillDownDialog();
    const isClickable = Boolean(drillDown && drillDownDialog && !isLoading);

    return (
        <Paper
            elevation={0}
            onClick={isClickable ? () => drillDownDialog!.openDrillDown(drillDown!) : undefined}
            sx={{
                ...createColoredCardSx(color),
                height: "100%",
                minHeight: 118,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                gap: 0.5,
                p: 2,
                ...(isClickable ? { cursor: "pointer", "&:hover": { filter: "brightness(1.06)" } } : {}),
            }}
        >
            <Box position="absolute" top={4} right={4}>
                <WidgetExplanation title={label} explanation={explanation} iconColor="rgba(255, 255, 255, 0.85)" />
            </Box>
            <Typography variant="body2" fontWeight={500} sx={{ color: "rgba(255, 255, 255, 0.92)" }}>
                {label}
            </Typography>
            {isLoading ? (
                <Skeleton variant="text" width={64} sx={{ fontSize: "2rem", bgcolor: "rgba(255, 255, 255, 0.3)" }} />
            ) : (
                <>
                    <Typography variant="h4" fontWeight={700} color="#fff">
                        {value}
                    </Typography>
                    {subtitle && (
                        <Typography variant="caption" sx={{ color: "rgba(255, 255, 255, 0.85)" }}>
                            {subtitle}
                        </Typography>
                    )}
                    {chips && chips.length > 0 && (
                        <Box display="flex" flexWrap="wrap" gap={0.5} justifyContent="center" mt={0.5}>
                            {chips.map((chip) => (
                                <Chip
                                    key={chip.label}
                                    size="small"
                                    label={`${chip.label}: ${chip.value}`}
                                    sx={{ bgcolor: "rgba(255, 255, 255, 0.22)", color: "#fff", fontWeight: 600, height: 22 }}
                                />
                            ))}
                        </Box>
                    )}
                </>
            )}
        </Paper>
    );
};
